import type { CityConfig } from "../city-template/types";

export const cincinnatiConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Hamilton County Probate Court", href: "https://www.hamiltoncountyohio.gov/probate", description: "Hamilton County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Hamilton County Clerk of Courts", href: "https://www.courtclerk.org/", description: "Hamilton County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Cincinnati",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "cincinnati",
  route: "/cities/cincinnati",
  title: "Emergency Passport Cincinnati, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cincinnati, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hamilton County and the Greater Cincinnati tri-state area including Northern Kentucky. Get your passport fast!",
  keywords: "expedited passport Cincinnati, emergency passport Cincinnati OH, same day passport Cincinnati, fast passport Hamilton County, passport renewal Cincinnati, 312 Walnut St passport office, CVG airport passport, Northern Kentucky passport, Cincinnati passport courier",
  h1: "Emergency & Expedited Passport Services in Cincinnati, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Cincinnati and Greater Cincinnati tri-state area travelers — including Northern Kentucky — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Cincinnati%20Ohio%20skyline%20panorama%20with%20the%20iconic%20Roebling%20Suspension%20Bridge%20over%20the%20Ohio%20River%20at%20golden%20hour%2C%20warm%20sunset%20light%20on%20downtown%20skyscrapers%20reflecting%20in%20the%20river%20water%2C%20the%20bridge%20cables%20glowing%20in%20amber%20light%20against%20a%20clear%20sky%2C%20dramatic%20perspective%20from%20Kentucky%20side%20showing%20Cincinnati%20waterfront%2C%20professional%20cityscape%20photography%20with%20vibrant%20colors&width=1800&height=700&seq=cincinnati-hero-ky-001&orientation=landscape",
  heroImageAlt: "Cincinnati Ohio skyline with Roebling Bridge over the Ohio River at golden hour",
  geoPosition: "39.1031;-84.5120",
  geoPlacename: "Cincinnati, Ohio",
  lastModified: "2026-07-18",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles from Cincinnati via I-74",
  },
  nearbyCitiesZips: [
    { name: "Cincinnati", zips: "45201–45275" },
    { name: "Covington, KY", zips: "41011, 41014, 41015, 41016" },
    { name: "Newport, KY", zips: "41071, 41072, 41073, 41075, 41076" },
    { name: "Florence, KY", zips: "41042" },
    { name: "Erlanger, KY", zips: "41018" },
    { name: "Fairfield", zips: "45014, 45018" },
    { name: "Mason", zips: "45040" },
    { name: "West Chester", zips: "45069, 45071" },
    { name: "Blue Ash", zips: "45241, 45242" },
    { name: "Loveland", zips: "45140" },
    { name: "Milford", zips: "45150" },
    { name: "Norwood", zips: "45212" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cincinnati departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Tri-State Coverage", desc: "Serving Ohio, Northern Kentucky, and southeast Indiana" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Covington, KY", route: "/covington" },
    { name: "Fast passport renewal in Louisville, KY", route: "/louisville" },
    { name: "Emergency passport help in Lexington, KY", route: "/lexington" },
    { name: "Urgent passport services in Dayton, OH", route: "/dayton" },
    { name: "Same-day passport help in Florence, KY", route: "/florence" },
    { name: "Passport courier services in Newport, KY", route: "/newport" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cincinnati from our local office at 312 Walnut St. Visit us by appointment, or use our courier pickup throughout Hamilton County, Northern Kentucky, and the Greater Cincinnati tri-state area.",
  fpcOfficeDistance: "312 Walnut St — Downtown Cincinnati",
  fpcOfficeAddress: "312 Walnut St, Cincinnati, OH 45202",
  officePhone: "(877) 253-0084",
  officeHours: [
    { days: "Monday – Friday", hours: "9:00 AM – 6:00 PM EST" },
    { days: "Saturday", hours: "10:00 AM – 2:00 PM EST" },
    { days: "Sunday", hours: "Closed" },
  ],
  officePhotoUrl: "https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/48297f2f-68d5-48d4-b308-ab2b2869a2d3_compressed_Cincinnati-fast-passport-center-office.webp",
  officePhotoAlt: "Fast Passport Center office building at 312 Walnut St in downtown Cincinnati, Ohio — modern glass skyscraper in the Central Business District",
  mapEmbedUrl: "https://maps.google.com/maps?q=312+Walnut+St,+Cincinnati,+OH+45202&t=&z=15&ie=UTF8&iwloc=&output=embed",
  areaServedList: [
    { "@type": "City", name: "Cincinnati" },
    { "@type": "City", name: "Covington" },
    { "@type": "City", name: "Newport" },
    { "@type": "City", name: "Florence" },
    { "@type": "City", name: "Erlanger" },
    { "@type": "City", name: "Fairfield" },
    { "@type": "City", name: "Mason" },
    { "@type": "City", name: "West Chester" },
    { "@type": "City", name: "Blue Ash" },
    { "@type": "City", name: "Loveland" },
    { "@type": "City", name: "Milford" },
    { "@type": "City", name: "Norwood" },
    { "@type": "AdministrativeArea", name: "Hamilton County" },
    { "@type": "AdministrativeArea", name: "Butler County" },
    { "@type": "AdministrativeArea", name: "Campbell County" },
    { "@type": "AdministrativeArea", name: "Kenton County" },
  ],
  serviceAreaDesc: "Fast Passport Center is a registered U.S. Department of State passport courier serving Cincinnati, Hamilton County, Northern Kentucky, and the Greater Cincinnati tri-state area with expedited passport processing as fast as 24 hours. A+ BBB rated. Located at 312 Walnut St, Cincinnati, OH 45202 near Fountain Square.",
  landmarks: [
    { name: "Fountain Square", distance: "0.1 mi", icon: "ri-map-pin-line", desc: "Cincinnati's iconic public square and gathering place" },
    { name: "Great American Ball Park", distance: "0.3 mi", icon: "ri-trophy-line", desc: "Home of the Cincinnati Reds — along the Ohio River waterfront" },
    { name: "Roebling Suspension Bridge", distance: "0.4 mi", icon: "ri-links-line", desc: "Historic bridge connecting Cincinnati to Northern Kentucky" },
    { name: "Paul Brown Stadium", distance: "0.5 mi", icon: "ri-trophy-line", desc: "Home of the Cincinnati Bengals" },
    { name: "Findlay Market", distance: "0.8 mi", icon: "ri-store-2-line", desc: "Ohio's oldest continuously operated public market" },
    { name: "CVG Airport", distance: "13 mi", icon: "ri-plane-line", desc: "Cincinnati/Northern Kentucky International Airport" },
    { name: "University of Cincinnati", distance: "3 mi", icon: "ri-graduation-cap-line", desc: "Major research university and medical center" },
    { name: "Kings Island", distance: "24 mi", icon: "ri-landscape-line", desc: "Major amusement park — popular summer destination" },
  ],
  serviceAreaIntro: "From downtown Cincinnati to the Northern Kentucky suburbs, from Hyde Park and Mt. Lookout to Mason and West Chester — Fast Passport Center serves the entire Greater Cincinnati tri-state region. We regularly help travelers from Covington, Florence, Erlanger, and Newport, KY get their passports fast.",
  nearbyCitiesIntro: "We serve all Cincinnati neighborhoods and the surrounding tri-state region including Covington KY, Newport KY, Florence KY, Erlanger KY, Fairfield, Mason, West Chester, Blue Ash, Loveland, Milford, Norwood, and across the river into southeast Indiana. If you are anywhere in the Greater Cincinnati metropolitan area, we have you covered.",
  howItWorksIntro: "Most Cincinnati travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Cincinnati travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Cincinnati and Greater Cincinnati tri-state area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cincinnati? Here are the most common ones we hear from Hamilton County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Cincinnati international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Damaged Passport", description: "Replacement for significantly damaged passports that are no longer valid for international travel." },
    { name: "Second Passport", description: "Second passport issuance for frequent travelers and business professionals who need a backup travel document." },
    { name: "Passport Card", description: "Wallet-size passport card for land and sea border crossings to Canada, Mexico, and the Caribbean." },
  ],
  testimonials: [
    {
      name: "Marcus R.",
      location: "Cincinnati, OH",
      rating: 5,
      text: "My passport expired two weeks before our family cruise to the Caribbean. Fast Passport Center had my renewal ready in 4 days. Incredible service — they kept me informed every step of the way.",
      service: "Passport Renewal",
    },
    {
      name: "Stephanie K.",
      location: "Covington, KY",
      rating: 5,
      text: "As someone living in Northern Kentucky, I thought I'd have to drive to Louisville or Chicago for an emergency passport. Fast Passport Center handled everything remotely — got mine in 36 hours.",
      service: "Emergency Passport",
    },
    {
      name: "David L.",
      location: "Mason, OH",
      rating: 5,
      text: "Business trip to London came up with only 5 days notice. They got me a passport in 3 business days. Professional team, great communication, and worth every penny.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer H.",
      location: "Florence, KY",
      rating: 5,
      text: "My daughter's first passport for her school trip to France. Fast Passport Center guided us through every document, found us the nearest acceptance facility, and had her passport ready in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "cincinnati-1",
      name: "Cincinnati Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 Vine St",
      city: "Cincinnati",
      state: "OH",
      zip: "45202",
      phone: "(513) 684-5667",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cincinnati, near Fountain Square",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility. High volume — appointments strongly recommended. Multiple windows available.",
      icon: "ri-mail-line",
    },
    {
      id: "cincinnati-2",
      name: "Hyde Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3233 Edwards Rd",
      city: "Cincinnati",
      state: "OH",
      zip: "45208",
      phone: "(513) 321-2741",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hyde Park neighborhood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for east-side Cincinnati residents. Less crowded than downtown. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "cincinnati-3",
      name: "Covington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 W Southern Ave",
      city: "Covington",
      state: "KY",
      zip: "41011",
      phone: "(859) 291-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Across the river in Northern Kentucky",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Excellent option for Northern Kentucky residents. Easier parking than downtown Cincinnati.",
      icon: "ri-mail-line",
    },
    {
      id: "cincinnati-4",
      name: "Mason Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "318 Reading Rd",
      city: "Mason",
      state: "OH",
      zip: "45040",
      phone: "(513) 398-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northern Cincinnati suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mason, West Chester, and Lebanon residents. Ample parking. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "cincinnati-5",
      name: "Hamilton County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "1000 Main St",
      city: "Cincinnati",
      state: "OH",
      zip: "45202",
      phone: "(513) 946-5600",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Hamilton County Courthouse",
      website: "https://www.courtclerk.org/",
      websiteLabel: "Hamilton County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "cincinnati-6",
      name: "Fairfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Miller Dr",
      city: "Fairfield",
      state: "OH",
      zip: "45014",
      phone: "(513) 829-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Butler County suburb, 15 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Butler County residents north of Cincinnati. Appointments required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots in Chicago", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 300 mile drive to Chicago via I-74", fpc: "Most Cincinnati travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Cincinnati-Specific Guidance", agency: "Generic — no CVG tri-state or manufacturing expertise", fpc: "Full Cincinnati/Chicago courier/tri-state corporate knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cincinnati photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hamilton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cincinnati applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hamilton County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cincinnati travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cincinnati." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cincinnati address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the Fast Passport Center office in Cincinnati?", a: "Our Cincinnati office is located at 312 Walnut St, Cincinnati, OH 45202 — in the heart of downtown near Fountain Square and the Roebling Suspension Bridge. You can visit by appointment, or use our courier pickup service throughout Hamilton County, Northern Kentucky, and the Greater Cincinnati tri-state area. We also offer prepaid overnight shipping labels so you can send documents from any UPS location." },
    { q: "Can I get an emergency passport in Cincinnati before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cincinnati for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Cincinnati?", a: "Fast Passport Center offers fast passport renewal in Cincinnati in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "I live in Northern Kentucky — can you still help me?", a: "Absolutely. Fast Passport Center serves the entire Greater Cincinnati tri-state area including all Northern Kentucky communities such as Covington, Newport, Florence, Erlanger, Independence, Fort Mitchell, and Fort Thomas. Our courier service works seamlessly from any zip code in the region." },
    { q: "Can I get a same-day passport appointment near Cincinnati?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Cincinnati — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hamilton County residents." },
    { q: "Can I expedite a child passport in Cincinnati?", a: "Yes. Fast Passport Center expedites child passports in Cincinnati for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hamilton County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Cincinnati with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Cincinnati?", a: "The nearest regional passport agency to Cincinnati is the Chicago Passport Agency, approximately 300 miles away via I-74. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cincinnati without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Cincinnati", address: "220 W 4th St, Cincinnati, OH 45202", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Hyde Park", address: "3245 Edwards Rd, Cincinnati, OH 45208", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "Walmart Supercenter — Eastgate", address: "4450 Eastgate Blvd, Cincinnati, OH 45245", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "FedEx Office — Cincinnati", address: "644 Vine St, Cincinnati, OH 45202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/office/passport-photos.html", websiteLabel: "FedEx Office" },
    { name: "CVS Pharmacy — Covington, KY", address: "3 W 5th St, Covington, KY 41011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Florence, KY", address: "7520 US-42, Florence, KY 42420", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Mason", address: "5830 Kings Mills Rd, Mason, OH 45040", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart — West Chester", address: "8995 Cincinnati-Dayton Rd, West Chester, OH 45069", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Hamilton County BMV — Cincinnati",
      address: "2000 E Crescentville Rd, Cincinnati, OH 45246",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Covington Circuit Court Clerk — KY",
      address: "316 Scott St, Covington, KY 41011",
      hours: "Mon–Fri: 8AM–4PM",
      note: "Kentucky driver's license and REAL ID for Northern Kentucky residents.",
      featured: false,
    },
    {
      name: "Butler County BMV — Fairfield",
      address: "8098 US Hwy 27, Fairfield, OH 45014",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Butler County and West Chester residents. REAL ID available.",
      featured: false,
    },
    {
      name: "AAA — Cincinnati",
      address: "12100 Sheraton Ln, Cincinnati, OH 45246",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "13 miles from downtown Cincinnati",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub serving the Greater Cincinnati tri-state area. Located in Northern Kentucky. Delta hub with direct flights to Europe, Mexico, and the Caribbean.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: true,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "55 miles north of Cincinnati",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative airport for north Cincinnati suburbs. Easier parking and security than CVG during peak periods.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "110 miles northeast of Cincinnati",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};